<template>
  <LoadingBlock :loading="loading">
    <div class="mb-4">
      <h6 class="mb-2">Что можно отредактировать</h6>
      <p class="text-muted mb-1">Вы можете изменить следующие значения заказа: </p>
      <ul class="text-muted mb-2">
        <li>Цена продажи</li>
        <li>Себестоимость</li>
        <li>Комиссия</li>
        <li>Налог</li>
      </ul>
      <p class="text-muted">Все значения указываются за 1 шт товара.</p>
    </div>
    <form @submit.prevent="onSubmit">
      <div class="col mb-4">
        <label class="form-label">Цена продажи</label>
        <input type="text" class="form-control" v-model.number="form.price" required>
      </div>
      <div class="col mb-4">
        <label class="form-label">Себестоимость</label>
        <input type="text" class="form-control" v-model.number="form.cost" required>
      </div>
      <div class="col mb-4">
        <label class="form-label">Комиссия</label>
        <input type="text" class="form-control" v-model.number="form.commission" required>
      </div>
      <div class="col mb-4">
        <label class="form-label">Налог</label>
        <input type="text" class="form-control" v-model.number="form.tax" required>
      </div>
      <div class="col mb-4">
        <button type="submit" class="btn btn-primary waves-effect waves-light">Сохранить</button>
      </div>
    </form>
  </LoadingBlock>
  </template>
  <script>
  import LoadingBlock from '@/components/page/LoadingBlock.vue'
  import {updateOrder} from '@/api/order'
  import {Message, Messages} from "@/data/messages";
  
  export default {
    name: 'OrderEdit',
    components: {LoadingBlock},
    props: {
      orderId: { type: [String, Number], required: true },
      modelValue: {
        type: Object,
        default: () => ({ price: 0, cost: 0, commission: 0, tax: 0 })
      }
    },
    emits: ['update:modelValue', 'success'],
    data(){
      return {
        loading: false,
        form: { price: 0, cost: 0, commission: 0, tax: 0 }
      }
    },
    watch: {
      modelValue: {
        deep: true,
        immediate: true,
        handler(v){
          this.form = { ...(v || { price: 0, cost: 0, commission: 0, tax: 0 }) }
        }
      }
    },
    methods: {
      async onSubmit(){
        this.loading = true
        try{
          const payload = {
            price: this.form.price ?? 0,
            cost: this.form.cost ?? 0,
            commission: this.form.commission ?? 0,
            tax: this.form.tax ?? 0
          }
          const res = await updateOrder(this.orderId, payload)
          const message = new Message()
          if(res.status === 200){
            message.type = 'success'
            message.text = 'Заказ обновлён'
            message.autoremove = 10
            this.$emit('success', payload)
          } else {
            message.type = 'failure'
            message.text = 'Не удалось обновить заказ'
          }
          Messages.list.push(message)
        } catch (e){
          const message = new Message()
          message.type = 'failure'
          message.text = 'Ошибка при обновлении заказа'
          Messages.list.push(message)
        } finally {
          this.loading = false
        }
      }
    }
  }
  </script>
  

